import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_105: FaireProductEntity = {
  token: "legacy_prod_abbott-105",
  type: "product",
  name: 'Large Sheep on Legs Planter 3" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/002b49a6fac53d0eebe794f8cf47c18c5bda8830dc3dcfa42ea38b59fcfcf012.jpeg",
  priceDollars: 22,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
